import type { Stats } from './perks';
import { SCAR_DEFS, MUTATION_DEFS, type ScarId, type MutationId } from '@cradle7/shared';

const SCAR_BY_ID = Object.fromEntries(SCAR_DEFS.map((s) => [s.id, s])) as Record<ScarId, typeof SCAR_DEFS[number]>;
const MUT_BY_ID = Object.fromEntries(MUTATION_DEFS.map((m) => [m.id, m])) as Record<MutationId, typeof MUTATION_DEFS[number]>;

export function applyScarMutationEffects(stats: Stats, scars: ScarId[], mutations: MutationId[]): Stats {
  let maxHpMul = 1;
  let damageMul = 1;
  let moveSpeedMul = 1;

  for (const id of scars) {
    const def = SCAR_BY_ID[id];
    if (!def) continue;
    if (def.effect.maxHpMul) maxHpMul *= def.effect.maxHpMul;
    if (def.effect.damageMul) damageMul *= def.effect.damageMul;
    if (def.effect.moveSpeedMul) moveSpeedMul *= def.effect.moveSpeedMul;
  }
  for (const id of mutations) {
    const def = MUT_BY_ID[id];
    if (!def) continue;
    if (def.effect.maxHpMul) maxHpMul *= def.effect.maxHpMul;
    if (def.effect.damageMul) damageMul *= def.effect.damageMul;
    if (def.effect.moveSpeedMul) moveSpeedMul *= def.effect.moveSpeedMul;
  }

  const newMaxHp = stats.maxHp * maxHpMul;
  return {
    ...stats,
    maxHp: newMaxHp,
    hp: newMaxHp,
    damageMultiplier: stats.damageMultiplier * damageMul,
    moveSpeed: stats.moveSpeed * moveSpeedMul,
  };
}

export function computePerkPickerDelta(scars: ScarId[], mutations: MutationId[]): number {
  let delta = 0;
  for (const id of scars) {
    const def = SCAR_BY_ID[id];
    if (def?.effect.perkPickerDelta) delta += def.effect.perkPickerDelta;
  }
  for (const id of mutations) {
    const def = MUT_BY_ID[id];
    if (def?.effect.perkPickerDelta) delta += def.effect.perkPickerDelta;
  }
  return delta;
}

export function computeBonusRevives(mutations: MutationId[]): number {
  let revives = 0;
  for (const id of mutations) {
    const def = MUT_BY_ID[id];
    if (def?.effect.bonusRevives) revives += def.effect.bonusRevives;
  }
  return revives;
}

export function computeFirstHitMul(scars: ScarId[]): number {
  for (const id of scars) {
    const def = SCAR_BY_ID[id];
    if (def?.effect.firstHitMul) return def.effect.firstHitMul;
  }
  return 1.0;
}
